import {
  Container,
  Button,
  Col,
  Form,
  InputGroup,
  Row,
  Modal,
} from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../services/api";
import "../css/register.css";
export default function RegisterPage() {
  const navigate = useNavigate();

  const [validated, setValidated] = useState(false);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    username: "",
    city: "",
    state: "",
    email: "",
    password: "",
    confirmPassword: "",
    agreed: false,
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false); // <<— MODALE

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((s) => ({
      ...s,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  async function handleRegister(event) {
    event.preventDefault();
    setValidated(true);
    setError("");
    setSuccess("");

    const form = event.currentTarget;
    if (!form.checkValidity()) {
      event.stopPropagation();
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords don't match.");
      return;
    }
    if (!formData.agreed) {
      setError("You must agree to the terms.");
      return;
    }

    setLoading(true);
    try {
      const payload = {
        firstName: formData.firstName,
        lastName: formData.lastName,
        username: formData.username,
        email: formData.email,
        password: formData.password,
        // evita null se il backend ha @NotBlank
        city: formData.city ?? "",
        state: formData.state ?? "",
      };

      // chiamata compatibile col tuo wrapper api() + log errore utile
      const res = await api("/api/auth/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: payload,
      });

      // se il tuo wrapper restituisce un Response, controlla status e leggi il body di errore
      if (res && typeof res.status === "number" && res.status >= 400) {
        const txt = typeof res.text === "function" ? await res.text() : "";
        console.error("REGISTER RAW ERROR:", res.status, txt);
        throw new Error(`REGISTER ${res.status} — ${txt || "server error"}`);
      }

      setSuccess("Registration successful!");
      setShowSuccessModal(true);
      setFormData({
        firstName: "",
        lastName: "",
        username: "",
        city: "",
        state: "",
        email: "",
        password: "",
        confirmPassword: "",
        agreed: false,
      });
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          err?.message ||
          "Registration failed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="global-register">
      <Container className="container-form">
        <Form
          noValidate
          validated={validated}
          onSubmit={handleRegister}
          autoComplete="off"
        >
          {/* anti password-manager (esche nascoste) */}
          <input
            type="text"
            name="fake-user"
            autoComplete="username"
            style={{ display: "none" }}
          />
          <input
            type="password"
            name="fake-pass"
            autoComplete="new-password"
            style={{ display: "none" }}
          />

          <Row className="mb-3">
            <Form.Group as={Col} md="4">
              <Form.Label>First name</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="First name"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                autoComplete="off"
              />
            </Form.Group>

            <Form.Group as={Col} md="4">
              <Form.Label>Last name</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="Last name"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                autoComplete="off"
              />
            </Form.Group>

            <Form.Group as={Col} md="4">
              <Form.Label>Username</Form.Label>
              <InputGroup hasValidation>
                <InputGroup.Text>@</InputGroup.Text>
                <Form.Control
                  required
                  type="text"
                  placeholder="Username"
                  name="username"
                  value={formData.username}
                  onChange={handleChange}
                  minLength={3}
                  autoComplete="off"
                  spellCheck="false"
                />
              </InputGroup>
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md="6">
              <Form.Label>City</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="City"
                name="city"
                value={formData.city}
                onChange={handleChange}
                autoComplete="off"
              />
            </Form.Group>
            <Form.Group as={Col} md="6">
              <Form.Label>State</Form.Label>
              <Form.Control
                required
                type="text"
                placeholder="State / Region"
                name="state"
                value={formData.state}
                onChange={handleChange}
                autoComplete="off"
              />
            </Form.Group>
          </Row>

          <Form.Group className="mb-3" controlId="regEmail">
            <Form.Label>Email</Form.Label>
            <Form.Control
              required
              type="email"
              placeholder="Your email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              autoComplete="off"
              inputMode="email"
              spellCheck="false"
            />
          </Form.Group>

          <Row className="mb-3">
            <Form.Group as={Col} md="6" controlId="regPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                required
                type="password"
                placeholder="Password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                minLength={8}
                autoComplete="new-password"
              />
              <Form.Text>At least 8 characters.</Form.Text>
            </Form.Group>

            <Form.Group as={Col} md="6" controlId="regConfirmPassword">
              <Form.Label>Confirm password</Form.Label>
              <Form.Control
                required
                type="password"
                placeholder="Confirm password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                minLength={8}
                autoComplete="new-password"
              />
            </Form.Group>
          </Row>

          <Form.Group className="mb-3">
            <Form.Check
              className="agrees"
              required
              name="agreed"
              checked={formData.agreed}
              onChange={handleChange}
              label="I agree to the terms and conditions"
              feedback="You must agree before submitting."
              feedbackType="invalid"
            />
          </Form.Group>

          <Button type="submit" disabled={loading} className="w-100">
            {loading ? "Creating account..." : "Create account"}
          </Button>

          {error && <p className="mt-3 text-danger">Error: {error}</p>}
          {success && <p className="mt-3 text-success">{success}</p>}
        </Form>

        <div className="text-center mt-3">
          Already have an account?{" "}
          <Button
            variant="link"
            onClick={() => navigate("/login")}
            className="p-0"
          >
            Sign in
          </Button>
        </div>
      </Container>

      {/* === Success Modal (post-registrazione) === */}
      <Modal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Registration successful</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>Your account has been created successfully.</p>
          <p>Please log in to continue.</p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            variant="primary"
            onClick={() => {
              setShowSuccessModal(false);
              navigate("/login");
            }}
          >
            Go to Login
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
